/**
 * @generated SignedSource<<51a06aee84d1057f43115d44978132b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "furniture" | "fashion" | "jewelry" | "art" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuTypeaheadContainer_itemSearch$data = {
  readonly topCategoryL1: VerticalType | null;
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly clearAllLinkReference: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbSharedRefineMenuTypeaheadContainer_itemSearch";
};
export type SbSharedRefineMenuTypeaheadContainer_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuTypeaheadContainer_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuTypeaheadContainer_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topCategoryL1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clearAllLinkReference",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "8b14178c100aca97ad632f33c5e1606e";

export default node;
